module.exports = __webpack_public_path__ + "img/balao_balao_4.5cb81a05.png";